import { IconGithub } from '@arco-design/web-react/icon';
import { useLocation, useNavigate } from 'react-router-dom';
import { Navigator } from '../../../../components/navigator';
import {
  LanguageContext,
  LanguageEnum,
  getCDNDomain,
  vgraphChangelogDefaultRoute,
  vgraphGuideDefaultRoute,
} from '../../../../utils';
import { useContext } from 'react';
import { NavigatorMobile } from '../../../../components/navigator/mobile';
import repoConfigs from '../../../../../repoConfigs.json';

const copyWritings = {
  example: {
    [LanguageEnum.chinese]: '关系图示例',
    [LanguageEnum.english]: 'Graph Examples',
  },
  guide: {
    [LanguageEnum.chinese]: '教程文档',
    [LanguageEnum.english]: 'Tutorials',
  },
  changelog: {
    [LanguageEnum.chinese]: '发布日志',
    [LanguageEnum.english]: 'Changelog',
  },
};

export interface IProps {
  selected?: string;
  style?: React.CSSProperties;
}

const TimerNavigator = Navigator();

export function VGraphNavigator(props: IProps) {
  const { language, setLanguage } = useContext(LanguageContext);
  const location = useLocation();
  const navigate = useNavigate();
  const isExampleListPage = location.pathname === '/vgraph/example';

  const version =
    repoConfigs.find((repo) => repo.repo.toLocaleLowerCase() === 'vgraph')
      ?.version ?? '';

  return (
    <TimerNavigator
      title={
        <a
          href="/vgraph"
          onClick={(event) => {
            navigate('/vgraph');
            event.preventDefault();
          }}
        >
          VGraph{' '}
          <span style={{ fontSize: '13px', fontWeight: 'normal' }}>
            {version}
          </span>
        </a>
      }
      style={props.style}
      left={[
        <a
          href="/vgraph/example"
          {...(props.selected === 'example' && isExampleListPage
            ? {
                className: 'navigator-link-selected',
                onClick: (event) => {
                  event.preventDefault();
                },
              }
            : {
                onClick: (event) => {
                  navigate('/vgraph/example');
                  event.preventDefault();
                },
              })}
        >
          {copyWritings.example[language]}
        </a>,
        <a
          href={`/vgraph/guide/${vgraphGuideDefaultRoute}`}
          {...(props.selected === 'guide'
            ? {
                className: 'navigator-link-selected',
                onClick: (event) => {
                  event.preventDefault();
                },
              }
            : {
                onClick: (event) => {
                  navigate(`/vgraph/guide/${vgraphGuideDefaultRoute}`);
                  event.preventDefault();
                },
              })}
        >
          {copyWritings.guide[language]}
        </a>,
        <a
          href={`/vgraph/changelog/${vgraphChangelogDefaultRoute}`}
          {...(props.selected === 'changelog'
            ? {
                className: 'navigator-link-selected',
                onClick: (event) => {
                  event.preventDefault();
                },
              }
            : {
                onClick: (event) => {
                  navigate(`/vgraph/changelog/${vgraphChangelogDefaultRoute}`);
                  event.preventDefault();
                },
              })}
        >
          {copyWritings.changelog[language]}
        </a>,
      ]}
      right={[
        <div
          onClick={() => {
            if (language === LanguageEnum.chinese) {
              setLanguage(LanguageEnum.english);
            } else {
              setLanguage(LanguageEnum.chinese);
            }
          }}
        >
          <img
            src={
              language === LanguageEnum.chinese
                ? `${getCDNDomain()}/img/common/language-ch.svg`
                : `${getCDNDomain()}/img/common/language-en.svg`
            }
            style={{ height: 24, paddingTop: 4 }}
          />
        </div>,
        <IconGithub
          style={{ width: 16, height: 16, cursor: 'pointer' }}
          onClick={() => {
            window.open('https://github.com/VisActor/VGraph');
          }}
        />,
      ]}
    />
  );
}

export function VGraphNavigatorMobile(props: IProps) {
  const { language } = useContext(LanguageContext);
  const location = useLocation();
  const navigate = useNavigate();
  const isExampleListPage = location.pathname === '/vgraph/example';

  return (
    <NavigatorMobile
      title={
        <a
          href="/vgraph"
          style={{ display: 'block', width: '100%', height: '100%' }}
          onClick={(event) => {
            navigate('/vgraph');
            event.preventDefault();
          }}
        >
          VGraph
        </a>
      }
      items={[
        <a
          href="/vgraph/example"
          style={{ display: 'block', width: '100%', height: '100%' }}
          onClick={(event) => {
            if (!isExampleListPage) {
              navigate('/vgraph/example');
            }
            event.preventDefault();
          }}
        >
          {copyWritings.example[language]}
        </a>,
        <a
          href={`/vgraph/guide/${vgraphGuideDefaultRoute}`}
          style={{ display: 'block', width: '100%', height: '100%' }}
          onClick={(event) => {
            navigate(`/vgraph/guide/${vgraphGuideDefaultRoute}`);
            event.preventDefault();
          }}
        >
          {copyWritings.guide[language]}
        </a>,
        <a
          href={`/vgraph/changelog/${vgraphChangelogDefaultRoute}`}
          style={{ display: 'block', width: '100%', height: '100%' }}
          onClick={(event) => {
            navigate(`/vgraph/changelog/${vgraphChangelogDefaultRoute}`);
            event.preventDefault();
          }}
        >
          {copyWritings.changelog[language]}
        </a>,
      ]}
    />
  );
}
